import React, { useState } from 'react';
import { fileUpload as fileUploadAPI } from '../../api/company';
import Image from '../Image';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../../utils/utilities';

import styles from './FileInput.module.scss';
import { has } from 'lodash';
import { fileTypes } from '../../utils';

export default (props) => {
  const { field, form, candidateId, accept } = props;
  const [fileName, setFileName] = useState('');

  const handleChange = (e) => {
    if (e?.currentTarget?.files.length) {
      const file = e?.currentTarget?.files[0];

      setFileName(e?.currentTarget?.files[0]?.name);

      const reader = new FileReader();

      if (props.uploadToServer && props.uploadToServer === 's3Upload') {
        props.setIsUploading(true);
        const request = {
          candidateId: candidateId,
          file: file,
          fileType: fileTypes[props?.field?.name]
        };

        fileUploadAPI(request)
          .then((response) => {
            form.setFieldValue(field.name, file);
            form.setFieldValue(props.files, file);
            form.setFieldValue(props.linkFieldName, response.data.data);
            props.setIsUploading(false);
            if (props?.accept === 'image/jpeg, image/png' && has(props, 'setIsCorrectLogoFormat')) {
              props?.setIsCorrectLogoFormat(true);
            }
          })
          .catch((error) => {
            if (props?.accept === 'image/jpeg, image/png' && has(props, 'setIsCorrectLogoFormat')) {
              props?.setIsCorrectLogoFormat(false);
            } else {
              toast.error(getErrorMessage(error));
            }
            form.setFieldValue(field.name, '');
          });
      } else {
        reader.readAsDataURL(file);
        form.setFieldValue(field.name, file);
      }
    }
  };

  return (
    <div className={styles.fileInputComponent}>
      <label>
        <div className={styles.fileInput}>
          <Image name='upload.svg' />
          <input
            accept={accept || 'image/*,application/pdf'}
            onChange={handleChange}
            type='file'
            name='Browse'
          />
          <span>Browse</span>
        </div>
        <div className={styles.selectedFileName}>
          {props.fileUrl ? (
            <a href={props.fileUrl} target='_blank'>
              {props.fileName}
            </a>
          ) : props.fileName ? (
            props.fileName
          ) : fileName ? (
            fileName
          ) : (
            'No file chosen'
          )}
        </div>
      </label>
    </div>
  );
};
